import { STATE_NAME } from "./weightIncrease.constants";

export const getEntities = state => state[STATE_NAME].entities;

export const getRedirect = state => state[STATE_NAME].ui.redirect;
